import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import it from './locales/it'

const currentLang = localStorage.getItem('edive-lang') || 'it'

async function loadLocale(lang: string): Promise<Record<string, unknown>> {
  switch (lang) {
    case 'en': return (await import('./locales/en')).default
    case 'zh': return (await import('./locales/zh')).default
    case 'ru': return (await import('./locales/ru')).default
    case 'ar': return (await import('./locales/ar')).default
    case 'de': return (await import('./locales/de')).default
    case 'es': return (await import('./locales/es')).default
    case 'fr': return (await import('./locales/fr')).default
    case 'nl': return (await import('./locales/nl')).default
    case 'fi': return (await import('./locales/fi')).default
    case 'pt': return (await import('./locales/pt')).default
    case 'tr': return (await import('./locales/tr')).default
    case 'ja': return (await import('./locales/ja')).default
    case 'id': return (await import('./locales/id')).default
    default:   return it
  }
}

i18n.use(initReactI18next).init({
  resources: { it: { translation: it } },
  lng: 'it',
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
})

async function ensureLocale(lang: string) {
  if (lang === 'it') return
  if (i18n.hasResourceBundle(lang, 'translation')) return
  const translations = await loadLocale(lang)
  i18n.addResourceBundle(lang, 'translation', translations)
}

if (currentLang !== 'it') {
  ensureLocale(currentLang).then(() => i18n.changeLanguage(currentLang))
}

i18n.on('languageChanged', (lng) => {
  if (!i18n.hasResourceBundle(lng, 'translation')) {
    ensureLocale(lng).then(() => i18n.changeLanguage(lng))
  }
})

export default i18n
